import React from 'react';
import { SvgIconProps } from '@material-ui/core';
import { Typography } from '../../../../ui-kit';
import { Circle, TotalContainer } from './style';

interface DetailsRowProps {
    icon: React.ComponentType<SvgIconProps>;
    title: string | number;
    subtitle: string;
}

const DetailsRow = ({ icon, title, subtitle }: DetailsRowProps) => {
    const Icon = icon;

    return (
        <TotalContainer>
            <Circle style={{ gridArea: 'icon' }}>
                <Icon fontSize='small' color='primary' />
            </Circle>
            <Typography
                style={{ gridArea: 'value' }}
                fontWeight='semiBold'
                variant='subtitle1'
            >
                {title}
            </Typography>
            <Typography
                style={{ gridArea: 'description' }}
                variant='caption'
            >
                {subtitle}
            </Typography>
        </TotalContainer>
    );
};

export default DetailsRow;